import React, { JSX, useContext, useEffect } from 'react';
import Layout from '../components/Layout';
import { PAGE_TITLE_SUFFIX } from '../constants';
import { BreadcrumbType, Store } from '../store';

const NotFound: React.FC = (): JSX.Element => {
  const { globalState, setGlobalState } = useContext(Store);

  // biome-ignore lint/correctness/useExhaustiveDependencies: マウント時に1度だけ実行
  useEffect(() => {
    const breadcrumbs: BreadcrumbType[] = [{ text: 'お探しのページが見つかりませんでした', path: '/' }];
    setGlobalState({ type: 'SET_BREADCRUMBS', payload: breadcrumbs });

    document.title = `ページが見つかりませんでした ${PAGE_TITLE_SUFFIX}`;

    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <article id="post-404" className="article-error404">
        <h1 className="error404-h1">お探しのページが見つかりませんでした</h1>
        <p>入力したアドレスが正しくないか、ページが移動した可能性があります</p>
        <p>
          <a href="https://help.sakura.ad.jp" className="error404-button">
            トップページに戻る
          </a>
        </p>
      </article>
    </Layout>
  );
};

export default NotFound;
